import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: LIGHT_GREY,
    alignItems: "center",
  },
  rootContent: { margin: theme.spacing(0, 2) },
  imgIcon: { width: theme.spacing(6), height: theme.spacing(6) },
}));
